/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class UserActivityApiService {
  seenArticles: string[] = [];

  constructor(private api: CustomerApiService) {}

  userActivity(data: any): Observable<any> {
    if (data.activity_type === 'article_open') {
      if (this.seenArticles && !this.seenArticles.includes(data.article_id)) {
        this.seenArticles.unshift(data.article_id);
      }
    }
    return this.api.post('/v1/user_activity/event', data);
  }

  getSearchActivity(n: number): Observable<any> {
    return this.api.get('/v1/user_activity/recent', { size: String(n) });
  }

  getSeenArticles(): Observable<any> {
    return this.api.get('/v1/user_activity/seen_articles');
  }

  postReferrer(source: string, url: string, payload: any): Observable<any> {
    return this.api.post('/v1/referrer_tracking', { source, url, payload });
  }
}
